<script>
  import { onMount } from "svelte";
  import { navigate } from "svelte-navigator";
  import { logout as _logout } from "../utils/auth";
  import { createEventDispatcher } from "svelte";
  import { navStore, headerDisplayStore, authStore } from "../stores/General";
  import config from "../assets/config";
import CustomIcon from "../components/CustomIcon.svelte";

  const dispatch = createEventDispatcher();
  const {user} = authStore



  export let showFullMenu;
  let show = false; // profilemenu state
  let menu = null; // profilemenu wrapper DOM reference
  let uiVersion = config.version;
  onMount(async () => {
    const handleOutsideClick = (event) => {
      if (show && !menu.contains(event.target)) {
        show = false;
      }
    };

    const handleEscape = (event) => {
      if (show && event.key === "Escape") {
        show = false;
      }
    };

    // add events when element is added to the DOM
    document.addEventListener("click", handleOutsideClick, false);
    document.addEventListener("keyup", handleEscape, false);

    // remove events when element is removed from the DOM
    return () => {
      document.removeEventListener("click", handleOutsideClick, false);
      document.removeEventListener("keyup", handleEscape, false);
    };
  });

  function logout() {
    _logout({
      returnTo: window.location.origin + "/login",
    });
  }

  function openProfile() {
    navStore.Select({ key: "settings" });
    navigate("/settings");
  }
  function openSettings() {
    navStore.Select({ key: "settings" });
    navigate("/settings");
  }
</script>

{#if $headerDisplayStore?.title}
  <!-- This example requires Tailwind CSS v2.0+ -->
  <div class="px-6 sticky z-10 bg-white">
    <div class="h-16 md:flex md:items-center md:justify-between">
      <div class="ml-2 mr-7">
        <button
          on:click={() => {
            showFullMenu = !showFullMenu;
            dispatch("toggleMenu", showFullMenu);
            localStorage.setItem("om_show_full_menu", showFullMenu);
          }}
          class="-ml-0.5 -mt-0.5 h-8 w-8 inline-flex items-center justify-center border-0 text-gray-500 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-yellow-500"
        >
          <span class="sr-only">Open sidebar</span>
          <!-- Heroicon name: outline/menu -->
         

          <CustomIcon height="18" width="20" viewBox="0 0 20 18" name="sbtoggler" color="black"/>
        </button>
      </div>

      <div class="flex-1 min-w-0">
        <div
          class="text-2xl font-semibold leading-7 text-gray-700 sm:truncate"
        >
          {$headerDisplayStore?.title}
        </div>
      </div>
      <!-- <div class="mx-1">
        <span class="sr-only">Bell</span>
        <CustomIcon width={16} height={16} name="bell"/>
        
      </div> -->
      <div class="ml-4 flex items-center md:ml-6">
        <!-- Profile dropdown -->
        <div class="relative">
          <div bind:this={menu}>
            <div
              type="button"
              on:click={() => (show = !show)}
              class="max-w-xs bg-white flex items-center text-sm outline-none shadow-none lg:hover:bg-gray-50 cursor-pointer"
              id="user-menu-button"
              aria-expanded="false"
              aria-haspopup="true"
            >
              {#if $user?.picture}
                <img class="h-6 w-6 rounded-full" src={$user?.picture} alt="" />
              {/if}
              <span
                class="hidden ml-3 mr-2 text-gray-700 text-sm font-medium lg:block leading-5"
                ><span class="sr-only"
                  >Open user menu for
                </span>{#if $user?.first_name}{$user?.first_name}{/if}</span
              >
              <!-- Heroicon name: solid/chevron-down -->
              
              <CustomIcon name="profiledown" color="#181818" width="8"
              height="5"/>
            </div>
          </div>

          <!--
              Dropdown menu, show/hide based on menu state.

              Entering: "transition ease-out duration-100"
                From: "transform opacity-0 scale-95"
                To: "transform opacity-100 scale-100"
              Leaving: "transition ease-in duration-75"
                From: "transform opacity-100 scale-100"
                To: "transform opacity-0 scale-95"
            -->
          {#if show}
            <div
              class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-40"
              role="menu"
              aria-orientation="vertical"
              aria-labelledby="user-menu-button"
              tabindex="-1"
            >
              <!-- Active: "bg-gray-100", Not Active: "" -->
              <div
                class="block px-4 py-2 text-sm text-gray-700 cursor-pointer"
                on:click={openProfile}
                role="menuitem"
                tabindex="-1"
                id="user-menu-item-0"
              >
                Your Profile
              </div>
              <div
                class="block px-4 py-2 text-sm text-gray-700 cursor-pointer"
                on:click={openSettings}
                role="menuitem"
                tabindex="-1"
                id="user-menu-item-1"
              >
                Settings
              </div>
              <div
                class="block px-4 py-2 text-sm text-gray-700 cursor-pointer"
                on:click={logout}
                role="menuitem"
                tabindex="-1"
                id="user-menu-item-2"
              >
                Logout
              </div>
              <div
                class="block px-4 py-2 text-xs text-right text-gray-700"
                role="menuitem"
                tabindex="-1"
                id="user-menu-version"
              >
                Version v{uiVersion}
              </div>
            </div>
          {/if}
        </div>
      </div>
    </div>
    <div class="my-2">
      <!-- <Breadcrumbs /> -->
    </div>
  </div>
{/if}
